import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            按类型快速浏览，找到你感兴趣的影视内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.slice(0, 4).map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-500/30 p-5 md:p-6 transition-all duration-300 cursor-pointer text-center"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/80 text-primary-600 mx-auto text-xl">
                <i className={item.icon}></i>
              </span>
              <h3 className="mt-3 text-sm md:text-base font-medium text-foreground-800">{item.title}</h3>
              <p className="mt-1 text-xs text-foreground-500">{item.count}</p>
            </div>
          ))}
        </div>

        <div className="mt-4 md:mt-5 grid grid-cols-3 gap-4 md:gap-5">
          {indexData.slice(4, 7).map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-500/30 p-4 md:p-5 transition-all duration-300 cursor-pointer flex items-center gap-3"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100/80 text-secondary-600 text-lg flex-shrink-0">
                <i className={item.icon}></i>
              </span>
              <div>
                <h3 className="text-sm font-medium text-foreground-800">{item.title}</h3>
                <p className="text-xs text-foreground-500">{item.count}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}